module.exports = __webpack_public_path__ + "media/images/ui__arrowDown--dark-04c33a2b30eb3b862fb4eea5429adda9.png";